import { render, staticRenderFns } from "./ElementStudio.vue?vue&type=template&id=d44346fc&"
import script from "./ElementStudio.vue?vue&type=script&lang=ts&"
export * from "./ElementStudio.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudio.vue?vue&type=style&index=0&id=d44346fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports